(() => {
  const navSelector = '[data-alhaq-mobile-bottom-nav]';
  const enabledClass = 'alhaq-mobile-bottom-nav-enabled';
  const syncDocumentState = () => {
    document.documentElement.classList.toggle(enabledClass, Boolean(document.querySelector(navSelector)));
  };

  syncDocumentState();

  if (window.alhaqMobileBottomNavInitialized) return;
  window.alhaqMobileBottomNavInitialized = true;

  const handleSectionUnload = (event) => {
    const unloadedSectionId = event.detail?.sectionId;

    const hasAnotherNav = Array.from(document.querySelectorAll(navSelector)).some(
      (nav) =>
        unloadedSectionId ? nav.dataset.sectionId !== unloadedSectionId : !event.target?.contains(nav)
    );
    document.documentElement.classList.toggle(enabledClass, hasAnotherNav);
  };

  document.addEventListener('shopify:section:load', syncDocumentState);
  document.addEventListener('shopify:section:unload', handleSectionUnload);

  const updateCartCount = (value) => {
    const count = Math.max(0, Number.parseInt(value, 10) || 0);

    document.querySelectorAll('[data-alhaq-mobile-cart]').forEach((cartLink) => {
      const nav = cartLink.closest('[data-alhaq-mobile-bottom-nav]');
      const badge = cartLink.querySelector('[data-alhaq-mobile-cart-count]');
      const countText = cartLink.querySelector('[data-alhaq-mobile-cart-text]');
      const countTemplate = count === 1 ? nav?.dataset.cartCountOne : nav?.dataset.cartCountOther;

      if (badge) badge.textContent = count > 99 ? '99+' : String(count);
      if (countText && countTemplate) countText.textContent = countTemplate.replace('[count]', String(count));
    });
  };

  const getCartCount = (cartData) => {
    if (cartData?.item_count != null) return cartData.item_count;

    const cartBubbleHtml = cartData?.sections?.['cart-icon-bubble'];
    if (typeof cartBubbleHtml !== 'string') return null;

    const cartBubble = new DOMParser()
      .parseFromString(cartBubbleHtml, 'text/html')
      .querySelector('.cart-count-bubble');
    if (!cartBubble) return 0;

    const visibleCount = cartBubble.querySelector('[aria-hidden="true"]')?.textContent || cartBubble.textContent;
    const match = visibleCount.match(/\d+/);
    return match ? Number.parseInt(match[0], 10) : null;
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const categoriesLink = event.target.closest('[data-alhaq-mobile-categories]');
    if (categoriesLink) {
      const drawerTrigger = document.querySelector(
        '#Details-menu-drawer-container > summary.header__icon--menu'
      );

      if (drawerTrigger) {
        event.preventDefault();
        drawerTrigger.click();
      }
      return;
    }

    const searchLink = event.target.closest('[data-alhaq-mobile-search]');
    if (!searchLink) return;

    const searchInput =
      document.getElementById('AlhaqHeaderSearch') ||
      document.querySelector('.alhaq-header-search input[type="search"]');
    if (!searchInput) return;

    event.preventDefault();
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    searchInput.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    searchInput.focus({ preventScroll: true });
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      const count = getCartCount(event.cartData);
      if (count != null) updateCartCount(count);
    });
  }
})();
